import React, { useState, useEffect } from 'react'
import { Row, Col, Form, FormGroup, Label, Input, Button } from "reactstrap"

import { connect } from "react-redux"
import { withRouter } from "react-router-dom"
import { loginUser, apiError } from "../../store/actions"
import toastr from 'toastr'

const Login = (props) => {
    const [nextPage] = useState(props.location?.state?.from?.pathname || '/')
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')

    useEffect(() => {
        const { error } = props

        if (error) {
            toastr.error('Utilizaste un usuario o password incorrecto', `Oop's`)
            props.apiError('')
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props?.error])

    const _handleSubmit = (e) => {
        e.preventDefault()

        if (!_validateNull()) {
            toastr.error('No olvides ingresar tu usuario y password')

            return false
        }

        props.loginUser({
            email, password
        }, props.history, nextPage)
    }

    const _validateNull = () => {
        if (email === '') { return false }
        if (password === '') { return false }

        return true
    }

    const __loginForm = () => {
        return (
            <div className="form">
                <h1>Iniciar Sesión</h1>

                <Row>
                    <Col sm={12}>
                        <FormGroup>
                            <Label htmlFor="name">
                                Email o Teléfono
                            </Label>
                            <Input
                                type="text"
                                className="form-control"
                                value={email}
                                onChange={event => setEmail(event.target.value)}
                            />
                        </FormGroup>
                    </Col>
                    <Col sm={12}>
                        <FormGroup>
                            <Label htmlFor="name">
                                Password
                            </Label>
                            <Input
                                type="password"
                                className="form-control"
                                value={password}
                                onChange={event => setPassword(event.target.value)}
                            />
                        </FormGroup>
                    </Col>
                </Row>

                <Row className='form-actions'>
                    <Col sm={12}>
                        <Button
                            type="submit"
                            color="primary"
                            className="btn btn-primary btn-rounded waves-effect waves-light mb-2 mr-2"
                        >
                            Iniciar Sesión
                        </Button>
                    </Col>
                </Row>
            </div>
        )
    }

    return(
        <React.Fragment>
            <div className="login">
                <div className="wrapper grid-layout">
                    <Form id="login" type="POST" onSubmit={ _handleSubmit }>
                        <div className="logo">
                            <img alt="Canvas Express" src="./assets/images/logo.png" />
                        </div>

                        { __loginForm() }
                    </Form>

                    <Row>
                        <Col sm={12} className="login-copyright">
                            <p>Hecho con amor por <a target="_blank" rel="noopener noreferrer" href="https://juvasoft.com/?utm_source=canvasexpress&utm_medium=login">Juvasoft</a></p>
                        </Col>
                    </Row>
                </div>
            </div>
        </React.Fragment>
    )
}

const mapStatetoProps = (state) => {
    const { error, profile } = state.Auth

    return { error, profile }
}

export default withRouter(
    connect(mapStatetoProps, { loginUser, apiError })(Login)
)
